export enum DateRange {
  AllTime = 'allTime',
  Custom = 'custom',
  Last12Months = 'last12Months',
  Last30Days = 'last30Days',
  Last90Days = 'last90Days',
  Last3Months = 'last3Months',
  Last7Days = 'last7Days',
  LastMonth = 'lastMonth',
}
